// FYSIK — shared behaviour
(function(){
  // Scroll position is left to the browser on purpose.
  //
  // This used to force every page to the top: scrollRestoration = 'manual'
  // plus scrollTo(0, 0) on a non-persisted pageshow. A fresh navigation
  // already opens at the top, so that bought nothing and cost three things.
  // pageshow fires after load, so a visitor who started scrolling while the
  // page was still arriving -- normal on a phone -- was yanked back to the
  // top the moment it finished. Reloading lost your place. So did going back
  // whenever the page was not served from the back/forward cache.

  // Header solidify on scroll (skip on pages flagged static-solid)
  const header = document.getElementById('header');
  if(header){
    if(header.classList.contains('static')){
      header.classList.add('solid');
    }else{
      const onScroll = () => header.classList.toggle('solid', window.scrollY > 40);
      onScroll();
      window.addEventListener('scroll', onScroll, {passive:true});
    }
  }

  // Reveal on scroll
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }});
  },{threshold:.12});
  const observeReveals = () => document.querySelectorAll('.reveal:not(.in)').forEach(el=>io.observe(el));
  observeReveals();
  window.__observeReveals = observeReveals;

  // Theme editor: a settings change re-renders just that section, and the observer
  // above (created at page load) never sees the freshly injected nodes, so their
  // .reveal elements would stay at opacity:0. Reveal them immediately in that case.
  document.addEventListener('shopify:section:load', (e)=>{
    const root = e.target && e.target.querySelectorAll ? e.target : document;
    root.querySelectorAll('.reveal').forEach(el=>el.classList.add('in'));
  });

  // Mobile menu overlay
  const burger = document.querySelector('.burger');
  const mobileMenu = document.getElementById('mobileMenu');
  if(burger && mobileMenu){
    const setMenu = (open)=>{
      document.body.classList.toggle('menu-open', open);
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
      mobileMenu.setAttribute('aria-hidden', String(!open));
    };
    burger.addEventListener('click', ()=> setMenu(!document.body.classList.contains('menu-open')));
    mobileMenu.addEventListener('click', (e)=>{ if(e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', (e)=>{ if(e.key === 'Escape' && document.body.classList.contains('menu-open')) setMenu(false); });
  }

  // Material Studio swatch configurator
  const swatches = document.getElementById('swatches');
  if(swatches){
    const img = document.getElementById('studioImg');
    const tag = document.getElementById('studioTag');
    const name = document.getElementById('finishName');
    const desc = document.getElementById('finishDesc');
    swatches.addEventListener('click', (ev)=>{
      const sw = ev.target.closest('.swatch');
      if(!sw) return;
      swatches.querySelectorAll('.swatch').forEach(s=>s.classList.remove('active'));
      sw.classList.add('active');
      img.style.filter = sw.dataset.filter;
      if(tag) tag.textContent = sw.dataset.name;
      if(name) name.textContent = sw.dataset.name;
      if(desc) desc.textContent = sw.dataset.desc;
    });
  }
})();

/* --- Image fade-in -------------------------------------------------------
   Mark every image that has not decoded yet, then clear the mark when it
   lands. Done in JS rather than CSS so that if this script never runs the
   images still show: no class means no opacity rule. Uses the capture phase
   because 'load' does not bubble. --------------------------------------- */
(function () {
  function settle(img) {
    img.classList.remove('img-pending');
    img.classList.add('is-loaded');
  }
  function tag(img) {
    if (img.dataset.fadeReady) return;
    img.dataset.fadeReady = '1';
    if (img.complete && img.naturalWidth > 0) return;   /* already cached */
    img.classList.add('img-pending');
  }
  function scan(root) {
    (root || document).querySelectorAll('img').forEach(tag);
  }
  document.addEventListener('load', function (e) {
    if (e.target.tagName === 'IMG') settle(e.target);
  }, true);
  document.addEventListener('error', function (e) {
    if (e.target.tagName === 'IMG') settle(e.target);   /* never leave it blank */
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  /* hover galleries and the configurator inject images after load */
  new MutationObserver(function (recs) {
    recs.forEach(function (r) {
      r.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'IMG') tag(n); else scan(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
